<template>

  <center>
    <el-row v-if="isTowerCo()">
      <dash-text
        caption="Share Ratio"
        :value="this.formatNumber(stats.sharingRatio, 2) + '%'"
        color="navy"
        icon="fa fa-share-alt"
        icon-color="lightgrey"
        no-plural
        align="center" />
    </el-row>

    <el-row v-if="stats">
      <table class="el-table">
        <tr v-if="stats.sitesActive">
          <td class="text-primary">Active</td>
          <td><b class="pull-right"><router-link class="el-button el-button--primary is-round is-plain el-button--mini" tag="el-button" to="sites/active">{{this.formatInteger(stats.sitesActive)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesCandidate">
          <td class="text-warning">Candidate</td>
<!--          <td v-if="isTelco()"><b class="text-warning pull-right">{{this.formatInteger(stats.sitesCandidate)}}</b></td> -->
          <td><b class="pull-right"><router-link class="el-button el-button--warning is-round is-plain el-button--mini" tag="el-button" to="sites/candidate">{{this.formatInteger(stats.sitesCandidate)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesDismantled">
          <td class="text-danger">Dismantled</td>
          <td><b class="pull-right"><router-link class="el-button el-button--danger is-round is-plain el-button--mini" tag="el-button" to="sites/dismantled">{{this.formatInteger(stats.sitesDismantled)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesExclusive">
          <td class="text-black">Exclusive</td>
          <td><b class="pull-right"><router-link class="el-button el-button--info is-round is-plain el-button--mini" tag="el-button" to="sites/exclusive">{{this.formatInteger(stats.sitesExclusive)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesLandOnly">
          <td class="text-info">Land Only</td>
          <td><b class="pull-right"><router-link class="el-button el-button--info is-round is-plain el-button--mini" tag="el-button" to="sites/land-only">{{this.formatInteger(stats.sitesLandOnly)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesNew">
          <td class="text-success">New</td>
<!--          <td v-if="isTelco()"><b class="text-success pull-right">{{this.formatInteger(stats.sitesNew)}}</b></td> -->
          <td><b class="pull-right"><router-link class="el-button el-button--success is-round is-plain el-button--mini" tag="el-button" to="sites/new">{{this.formatInteger(stats.sitesNew)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesSold">
          <td class="text-info">Sold</td>
          <td><b class="pull-right"><router-link class="el-button el-button--danger is-round is-plain el-button--mini" tag="el-button" to="sites/sold">{{this.formatInteger(stats.sitesSold)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesTemporary">
          <td class="text-info">Temporary</td>
          <td><b class="pull-right"><router-link class="el-button el-button--info is-round is-plain el-button--mini" tag="el-button" to="sites/temporary">{{this.formatInteger(stats.sitesTemporary)}}</router-link></b></td>
        </tr>
        <tr v-if="stats.sitesTotal">
          <th></th>
          <th><b class="pull-right"><router-link class="el-button is-round is-plain el-button--mini" tag="el-button" to="sites">{{this.formatInteger(stats.sitesTotal)}}</router-link></b></th>
        </tr>
      </table>
    </el-row>


    <div  v-if="isTowerCo()">
      <el-row>
        Total Sharers: <b>{{this.formatNumber(stats.sharers, 0)}}</b>
      </el-row>
      <el-row>
        Total Exclude Sharers: <b>{{this.formatNumber(stats.excludeSharers, 0)}}</b>
      </el-row>
      <el-row>
        Total Ways: <b>{{this.formatNumber(stats.totalWays, 0)}}</b>
      </el-row>
    </div>

  </center>

</template>

<script>
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [NumberMixins],

  data () {
    return {
      stats: null
    }
  },

  created () {
    this.stats = this.getStats()
  }
}

</script>
